import { createFileRoute } from '@tanstack/react-router';

import { Home } from '~/modules/home';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { getRouteHead } from '~/utils/routeUtils';

const title = i18n.t(($) => $.pageTitle, { ns: 'home' });

export const Route = createFileRoute('/(main)/')({
  component: Home,
  head: () => getRouteHead(title),
  staticData: {
    AppBar: {
      title,
    },
  },
});

export const DASHBOARD = buildRouteExport({
  Route,
});
